// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { operatorId } from './Operator';
import { z } from 'zod';
export const steadyStateId = (z.number());
export const steadyState = z.object({
    id: steadyStateId,
    fermentation_id: fermentationId,
    name: z.string().nullable(),
    auto_name: z.string(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const steadyStateInitializer = z.object({
    id: steadyStateId.optional(),
    fermentation_id: fermentationId,
    name: z.string().optional().nullable(),
    auto_name: z.string(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const steadyStateMutator = z.object({
    id: steadyStateId.optional(),
    fermentation_id: fermentationId.optional(),
    name: z.string().optional().nullable(),
    auto_name: z.string().optional(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=SteadyState.js.map